import { useFormikContext } from 'formik';

export const useFormikFieldChange = () => {
  const formik = useFormikContext();

  const setField = async (name, value) => {
    const wasAlreadyTouched = formik.touched[name];
    await formik.setFieldValue(name, value);

    if (wasAlreadyTouched) {
      await formik.validateField(name);
    }
  };

  const handleFieldChange = (event) => setField(event.target.name, event.target.value);

  return { formik, setField, handleFieldChange };
};
